module.exports = __webpack_public_path__ + "static/img/career-course-image4.06b12732.png";